import { Component, EventEmitter, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-user-form',
  templateUrl: './user-form.component.html',
  styleUrls: ['./user-form.component.css']
})
export class UserFormComponent implements OnInit {
  @Output() customerDetails = new EventEmitter<any> ();
  customerValues: any;
  customerName: string;
  customerPlace: string;
  customerPhone: string;
   
  constructor() { }

  ngOnInit(): void {
  }
  

  onAddCustometDetails( customerNameInput , customerPlaceInput , customerPhoneInput :HTMLInputElement){
    this.customerValues = {
      customerName: customerNameInput.value,
      customerPlace: customerPlaceInput.value,
      customerPhone : customerPhoneInput.value
    }
  //  this.customerName = customerNameInput.value;
  //   this.customerPlace = customerPlaceInput.value;
  //   this.customerPhone = customerPhoneInput.value;
    this.customerDetails.emit(this.customerValues);
  }

}
